import { lazy, Suspense, useState } from 'react';
import { Button, Segmented, Space, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../../components/common/PageHeader';

// react-big-calendar es pesado y trae CSS: se carga diferido (chunk aparte).
const ActivitiesCalendar = lazy(() => import('../components/ActivitiesCalendar'));

type Scope = 'all' | 'mine';

export function CalendarPage(): JSX.Element {
  const navigate = useNavigate();
  const [scope, setScope] = useState<Scope>('all');

  return (
    <>
      <PageHeader
        title="Calendario"
        crumbs={[{ title: 'Actividades', to: '/actividades' }, { title: 'Calendario' }]}
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/actividades/nueva')}
          >
            Nueva actividad
          </Button>
        }
      />

      <Space style={{ marginBottom: 16 }}>
        <Segmented
          options={[
            { label: 'Todas', value: 'all' },
            { label: 'Mías', value: 'mine' },
          ]}
          value={scope}
          onChange={(v) => setScope(v as Scope)}
        />
      </Space>

      <Suspense
        fallback={
          <div style={{ textAlign: 'center', padding: 48 }}>
            <Spin />
          </div>
        }
      >
        <ActivitiesCalendar mine={scope === 'mine'} />
      </Suspense>
    </>
  );
}
